import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Feeds } from '../models/feeds';

@Injectable({
  providedIn: 'root'
})
export class WebService {

  constructor(
    private http:HttpClient
  ) { }

  saveFeed(feedVo: Feeds): any {
    return this.http.post('/feed/save', feedVo);
  }

  checkUserxists(emailId:String):any {
  return this.http.get('https://c6agck7r5u3bdhxixqjutlhine0emldf.lambda-url.us-west-1.on.aws/?param1='+emailId);
  }


  addUser(adduserVo:any):any{
    return this.http.post("https://abdr6qqxkcntsj5dhu4j5dy7ui0cujub.lambda-url.us-west-1.on.aws/",adduserVo);
  }

  conFirmUser(adduserVo:any):any{
    return this.http.post(" https://e3uonuclcxos3tklhula5daxha0zqckc.lambda-url.us-west-1.on.aws/",adduserVo);
  }

  changeUserPassword(adduserVo:any):any{
    return this.http.post("https://juolizq6wivr23bkalqhmm56om0cvnzd.lambda-url.us-west-1.on.aws/",adduserVo);
  }


  getOptionListByGroup(groupName:String):any {
    return this.http.get('https://x726eayb4sq3byg4twudqumdd40jtiop.lambda-url.us-west-1.on.aws/?param1='+groupName);
    }
  

}
